<angular-editor id="sleep" [(ngModel)]="content" [config]="editorConfig" (ngModelChange)="contentChanged()"></angular-editor>
